import { useNavigation } from 'adapter/in/dashboards/hooks/useNavigation';
import React, { useCallback } from 'react';

export const useOnEditDashboardAction = () => {
    const { navigationPush } = useNavigation();
    const handleOnEdit = useCallback((dashboardId: string) => navigationPush(`${dashboardId}/edit`), []);

    return { handleOnEdit };
};
